import React from 'react'
import { ClickAwayListener } from '@material-ui/core';
import { AnimatePresence, motion } from 'framer-motion';
import { IPosition } from '../../CellWithFilter';


interface IFilterContainerProps {
  children: React.ReactNode;
  onClickAway: (event: any) => void;
  styles: Record<string, any>;
  position: IPosition;
  isOpen: boolean;
  onAnimationEnd: () => void;
}

const PRESENCE_ANIMATION = {
  initial: {
    opacity: 0,
  },

  animate: {
    opacity: 1,
  },

  exit: {
    opacity: 0,
  },

  transition: { duration: 0.25 },
};

const Container: React.FC<IFilterContainerProps> = ({
  isOpen,
  onAnimationEnd,
  onClickAway,
  position,
  children,
  styles,
}) => (
  <AnimatePresence>
    {isOpen && (
      <motion.div onAnimationEnd={onAnimationEnd} {...PRESENCE_ANIMATION}>
        <ClickAwayListener onClickAway={onClickAway}>
          <div style={{ ...position }} className={styles.filterContainer}>
            {children}
          </div>
        </ClickAwayListener>
      </motion.div>
    )}
  </AnimatePresence>
);

export default Container;
